import { Component, inject, OnDestroy } from '@angular/core';
import { NgProgressService } from '@shared/services/ng-progress.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CardModule } from 'primeng/card';
import { MyProperty, Portfolio } from './portfolio.model';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ProfileService } from '../profile/profile.service';
import { PortfolioService } from './portfolio.service';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { Popover } from 'primeng/popover';
import { ButtonModule } from 'primeng/button';
import { PortfolioGrowthChartComponent } from '@shared/components/portfolio-growth-chart/portfolio-growth-chart.component';
import { DatePipe } from '@angular/common';
import { Category } from '../properties/properties.model';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { DocumentsService } from '@shared/services/documents.service';
import { Document } from '../properties/properties.model';
import { CustomCurrencyPipe } from '@shared/pipes/custom-currency.pipe';

@Component({
  selector: 'app-portfolio',
  imports: [
    CommonModule,
    CardModule,
    AngularSvgIconModule,
    TableModule,
    SkeletonModule,
    Popover,
    ButtonModule,
    PortfolioGrowthChartComponent,
    DividerModule,
    DialogModule,
    CustomCurrencyPipe,
  ],
  templateUrl: './portfolio.component.html',
})
export class PortfolioComponent implements OnDestroy {
  currency: string | undefined;
  portfolio: Portfolio | null = null;
  growthOverviewChartDates: string[] = [];
  myProperties: MyProperty[] = [];
  categoryEnum = Category;
  isTouchDevice: boolean = false;

  private portfolioSub = Subscription.EMPTY;
  private myPropertiesSub = Subscription.EMPTY;

  readonly _portfolioService = inject(PortfolioService);
  private readonly _ngProgressService = inject(NgProgressService);
  private readonly _profileService = inject(ProfileService);
  private readonly _documentsService = inject(DocumentsService);

  ngOnInit(): void {
    this.isTouchDevice = matchMedia('(pointer: coarse)').matches;
    this._ngProgressService.startLoader();

    this.currency = this._profileService.profile.currency;

    this.portfolioSub = this._portfolioService.portfolio$.subscribe(
      (portfolio) => {
        this.portfolio = portfolio;

        this.parseGrowthOverviewChartDates(
          this.portfolio?.growthOverviewChartDates
        );
      }
    );

    this.myPropertiesSub = this._portfolioService.myProperties$.subscribe(
      (myProperties) => {
        this.myProperties = myProperties;
      }
    );

    this._portfolioService.getPortfolio();
    this._portfolioService.getMyProperties();
  }

  ngAfterViewInit(): void {
    this._ngProgressService.completeLoader();
  }

  onDownloadDocument(document: Document, event: Event): void {
    event.preventDefault(); // Prevents navigation
    event.stopPropagation(); // Stops event from bubbling to <a>

    const documentUrl = document.url;
    const documentName = `${document.name}.${document.type}`;

    this._documentsService.onDownloadDocument(documentUrl, documentName);
  }

  private parseGrowthOverviewChartDates(
    growthOverviewChartDates: Date[] | undefined
  ): void {
    if (!growthOverviewChartDates) {
      this.growthOverviewChartDates = [];
      return;
    }

    const datePipe = new DatePipe('en-US');
    this.growthOverviewChartDates = growthOverviewChartDates!.map(
      (date) => datePipe.transform(date, 'd MMM y')!
    );
  }

  ngOnDestroy(): void {
    this.portfolioSub.unsubscribe();
    this.myPropertiesSub.unsubscribe();
  }
}
